import { createSvgComponent } from "../../icon/createSvgComponent";
import Notice from "@core/icon/assets/notice.svg";
export default createSvgComponent(Notice);